import { TSelectOption } from '@interfaces/components/componentTypes';

import { EAlarmStatus, EAlarmStatusTitle } from '@enums/alarms';
import { defaultMeta, EMenuActionsTypes, EVendorsValues, TVendorsValues } from '@enums/common';

export const TOP_OFFSET = '200px';

export const ACTIVE_ALARMS_TABS_NAMES = {
	activeAlarms: 'Active Alarms',
	historyAlarms: 'Alarms History',
};

export const ALARM_TABLE_EMPTY_TEXT = 'No alarms available for selected filtering options';

const DEFAULT_TAB = {
	page: defaultMeta.page,
	pageSize: defaultMeta.pageSize,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	toDate: null,
	fromDate: null,
	filter: {},
};

export const DEFAULT_TABS = {
	[ACTIVE_ALARMS_TABS_NAMES.activeAlarms]: DEFAULT_TAB,
	[ACTIVE_ALARMS_TABS_NAMES.historyAlarms]: DEFAULT_TAB,
};

export const ALARM_TABS = [
	{
		title: ACTIVE_ALARMS_TABS_NAMES.activeAlarms,
		value: ACTIVE_ALARMS_TABS_NAMES.activeAlarms,
		isVisible: true,
	},
	{
		title: ACTIVE_ALARMS_TABS_NAMES.historyAlarms,
		value: ACTIVE_ALARMS_TABS_NAMES.historyAlarms,
		isVisible: true,
	},
];

export const statusAlarmHistoryOptions: TSelectOption[] = [
	{
		label: EAlarmStatusTitle.active,
		value: EAlarmStatus.active,
		name: EAlarmStatusTitle.active,
	},
	{
		label: EAlarmStatusTitle.inactive,
		value: EAlarmStatus.cleared,
		name: EAlarmStatusTitle.inactive,
	},
];

export const statusAlarmHistoryFlexiDasOptions: TSelectOption[] = [
	{
		label: EAlarmStatusTitle.active,
		value: true,
		name: EAlarmStatusTitle.active,
	},
	{
		label: EAlarmStatusTitle.inactive,
		value: false,
		name: EAlarmStatusTitle.inactive,
	},
];

export const columnHeaders: Record<string, Partial<Record<TVendorsValues, string>>> = {
	actions: {
		[EVendorsValues.limenet]: 'actions',
		[EVendorsValues.oran]: 'actions',
		[EVendorsValues.benetel]: 'actions',
	},
	alarmCode: {
		[EVendorsValues.flexidas]: 'alarmCode',
	},
	alarmDasIndex: {
		[EVendorsValues.flexidas]: 'alarmDasIndex',
	},
	alarmId: {
		[EVendorsValues.limenet]: 'alarmId',
		[EVendorsValues.oran]: 'alarmId',
		[EVendorsValues.benetel]: 'alarmId',
	},
	alarmName: {
		[EVendorsValues.limenet]: 'name',
		[EVendorsValues.flexidas]: 'alarmName',
		[EVendorsValues.oran]: 'name',
		[EVendorsValues.benetel]: 'name',
	},
	alarmPathName: {
		[EVendorsValues.flexidas]: 'alarmPathName',
	},
	applicability: {
		[EVendorsValues.oran]: 'applicability',
		[EVendorsValues.benetel]: 'applicability',
	},
	cleared: {
		[EVendorsValues.flexidas]: 'alarmClearedTimeAtText',
	},
	clearedAtText: {
		[EVendorsValues.limenet]: 'clearedAtText',
		[EVendorsValues.oran]: 'clearedAtText',
		[EVendorsValues.benetel]: 'clearedAtText',
		[EVendorsValues.flexidas]: 'alarmClearedTimeAtText',
	},
	clearedType: {
		[EVendorsValues.oran]: 'clearedType',
		[EVendorsValues.benetel]: 'clearedType',
	},
	crowdcellSystemId: {
		[EVendorsValues.limenet]: 'crowdcellSystemId',
	},
	description: {
		[EVendorsValues.flexidas]: 'alarmMessage',
	},
	duration: {
		[EVendorsValues.limenet]: 'durationMinutes',
		[EVendorsValues.oran]: 'durationMinutes',
		[EVendorsValues.benetel]: 'durationMinutes',
	},
	groups: {
		[EVendorsValues.limenet]: 'groups',
		[EVendorsValues.oran]: 'groups',
		[EVendorsValues.benetel]: 'groups',
	},
	isAcknowledged: {
		[EVendorsValues.oran]: 'isAcknowledged',
		[EVendorsValues.benetel]: 'isAcknowledged',
	},
	isActive: {
		[EVendorsValues.limenet]: 'isActive',
	},
	middlewareName: {
		[EVendorsValues.oran]: 'middlewareName',
		[EVendorsValues.benetel]: 'middlewareName',
	},
	moduleName: {
		[EVendorsValues.oran]: 'moduleName',
		[EVendorsValues.benetel]: 'moduleName',
	},
	networkElementName: {
		[EVendorsValues.oran]: 'networkElementName',
		[EVendorsValues.benetel]: 'networkElementName',
	},
	probableCause: {
		[EVendorsValues.oran]: 'probableCause',
		[EVendorsValues.benetel]: 'probableCause',
	},
	raisedAtText: {
		[EVendorsValues.limenet]: 'createdAtText',
		[EVendorsValues.oran]: 'alarmTimeText',
		[EVendorsValues.benetel]: 'alarmTimeText',
		[EVendorsValues.flexidas]: 'alarmReceivedTimeAtText',
	},
	severity: {
		[EVendorsValues.limenet]: 'severity',
		[EVendorsValues.flexidas]: 'alarmSeverity',
		[EVendorsValues.oran]: 'alarmSeverity',
		[EVendorsValues.benetel]: 'alarmSeverity',
	},
	siteId: {
		[EVendorsValues.limenet]: 'siteId',
	},
	status: {
		[EVendorsValues.limenet]: 'status',
		[EVendorsValues.oran]: 'status',
		[EVendorsValues.benetel]: 'status',
	},
	triggerCondition: {
		[EVendorsValues.limenet]: 'triggerCondition',
	},
};

export const exportActions = [
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
	},
	{
		text: 'All filtered',
		id: EMenuActionsTypes.allFiltered,
		disabled: false,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
];
